module.exports = __webpack_public_path__ + "img/dice-three.8e3283b1.svg";